@import 'styles/mixins';

.root {
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;

  &.eventCard {
    flex: 1 0 0;
    padding: 4px 7.6px 9px 9px;
  }

  &.fullScreenPreview {
    justify-content: center;

    width: 347.983px;
    height: 686px;
    padding: 0 113.491px 0 115.491px;
    gap: 13px;

    border-radius: 10.45px;
    border: 1.067px solid var(--dark-8);
    background: var(--light-100);
    box-shadow: 0 21.349px 85.395px 0 var(--dark-10);

    @include for-phone-only {
      width: 100%;
      height: 400px;
    }
  }
}

.container {
  display: flex;
  padding: 47px 25px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 4px;
}

.description {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  span {
    line-height: 114% !important;
    letter-spacing: 0.42px !important;
  }
}

.fullScreenDescription {
  display: flex;
  width: 132px;
  flex-direction: column;
  align-items: center;

  h5 {
    text-align: center;
  }
}

.retryButton {
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;

  z-index: 2;
}
